module.exports = __webpack_public_path__ + "static/media/2.160ac27f.jpeg";